const topicItems = [
  { label: '暑期档2026', hot: true },
  { label: '悬疑烧脑', hot: true },
  { label: '国产动画', hot: true },
  { label: '高分韩剧', hot: false },
  { label: '经典重温', hot: false },
  { label: '科幻大片', hot: true },
  { label: '治愈日剧', hot: false },
  { label: '武侠玄幻', hot: false },
  { label: '奥斯卡', hot: false },
  { label: '纪录片精选', hot: false },
  { label: '港片情怀', hot: true },
];

export default function SectionTopics() {
  return (
    <section id="topics" className="bg-background-100 py-16 md:py-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 whitespace-nowrap mb-3">
            话题聚焦
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="text-foreground-600 text-sm mt-2">当下最受关注的影视话题，看看大家都在讨论什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item, index) => (
            <div
              key={index}
              className={`relative inline-flex items-center gap-1.5 px-4 py-2 rounded-full cursor-pointer transition-colors text-sm font-medium whitespace-nowrap ${
                item.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 text-foreground-700 border border-background-200 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              {item.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
              )}
              {item.label}
              {item.hot && (
                <span className="text-[10px] opacity-80 ml-0.5">HOT</span>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-foreground-500 text-xs md:text-sm">
            以上话题标签基于近7日全网影视讨论数据生成，热度每小时更新
          </p>
        </div>
      </div>
    </section>
  );
}